export default __webpack_public_path__ + "0e6ae957af6c3d20bda74296ffee9534.png";